var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.list,"row-key":record => record.id,"scroll":{ x:0, y: 500 },"pagination":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }